import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';
import { FaqsComponent } from '../../../../widgets/faqs/faqs.component';
import { FaqItem } from '../../../../core/interface/faq.modal';

@Component({
  selector: 'app-incident-management-software',
  standalone: true,
  imports: [CommonModule, RouterModule, FeatureHero, FaqsComponent],
  templateUrl: './incident-management-software.html',
  styleUrl: './incident-management-software.scss',
})
export class IncidentManagementSoftware {
  faqs: FaqItem[] = [
    {
      question: 'What is incident management?',
      answer: {
        paragraphs: ['Incidents can crop up at any time and from unexpected sources, causing unplanned interruptions in service quality. These incidents must be managed promptly to prevent downtime and unhappy customers. Managing the incident is imperative to restoring IT services and reducing the impact of disruptions on business.']
      }
    },
    {
      question: 'What is the objective of incident management?',
      answer: {
        paragraphs: ['The objective is to restore normalcy in service operations as quickly as possible, and minimize the impact of unforeseen incidents so that your business continues to fulfil the SLA as agreed.']
      }
    },
    {
      question: 'Why does an enterprise need incident management solutions?',
      answer: {
        paragraphs: ["Service disruptions because of incidents can harm the business's reputation and the bottom line. Therefore, it is necessary to manage incidents through an efficient process, to respond to and resolve incidents promptly. Incident management solutions can keep you from deviating from SLAs, reduce manual tasks and human errors, and cut down service desk's workloads, thereby improving service quality and ROI."]
      }
    },
    {
      question: 'What are the content of incident management?',
      answer: {
        list: {
          type: 'ul',
          items: ['Proactive in identifying incidents', 'Streamlined business operations', 'Increased productivity', 'Consistent service quality', 'Enhanced customer satisfaction']
        }
      }
    },
    {
      question: 'How does AI-powered incident management tool differ from traditional solutions?',
      answer: {
        paragraphs: ["AI-powered tools automatically categorize and prioritize incidents, predict potential issues before they escalate, and provide intelligent recommendations for faster resolution. Unlike traditional manual approaches, they offer proactive incident detection, smart agent assignment based on skills and availability, and can resolve up to 80% of tickets with minimal human intervention."]
      }
    },
    {
      question: 'What ROI can enterprises expect from implementing an IT incident management tool?',
      answer: {
        paragraphs: ["Organizations typically see immediate improvements: 75% increase in agent productivity, 75% reduction in IT expenses, enhanced customer satisfaction by over 75%, and significantly reduced downtime costs. Most enterprises achieve positive ROI within 6-12 months through automated workflows, faster resolution times, and better resource optimization."]
      }
    },
    {
      question: 'How does incident prioritization work in incident management software?',
      answer: {
        paragraphs: ["The software uses AI algorithms to automatically assess incidents based on business impact and urgency levels. It considers factors like affected users, service criticality, and SLA requirements to assign appropriate priority levels. Critical incidents get immediate attention with auto-escalation if SLAs aren't met, while routine issues follow standard workflows through the self-service portal."]
      }
    }
  ];
}
